import type {CSSObject, Theme} from "@emotion/react";
import styled from "@emotion/styled";

function gridText(isLeftPosition: boolean, theme: Theme): string {
  if (theme?.breakpoints?.isMobile) {
    return "1/-1";
  }
  if (theme?.breakpoints?.md) {
    return isLeftPosition ? "9/16" : "2/9";
  }
  return isLeftPosition ? "8/15" : "3/10";
}

export const TextWrapper = styled.div<{isLeftPosition?: boolean; isMobile?: boolean}>(
  ({isLeftPosition, theme}) => ({
    height: "auto",
    gridColumn: gridText(!!isLeftPosition, theme),
    paddingInline: theme?.breakpoints?.isMobile ? 10 : 0,
  }),
);

function gridImage(isLeftPosition: boolean, theme: Theme): string {
  if (theme?.breakpoints?.isMobile) {
    return isLeftPosition ? "1/4" : "2/-1";
  }
  if (theme?.breakpoints?.md) {
    return isLeftPosition ? "1/8" : "10/-1";
  }
  return "1/-1";
}

export const ImageWrapper = styled.div<{
  imageUrl?: string;
  isLeftPosition?: boolean;
  credit?: string;
  isMobile?: boolean;
}>(({imageUrl, isLeftPosition, credit, theme}) => ({
  position: theme?.breakpoints?.isMobile ? "relative" : "sticky",
  top: theme?.breakpoints?.isMobile ? "initial" : 120,
  aspectRatio: "600 / 800",
  gridColumn: gridImage(!!isLeftPosition, theme),
  // the credit hangs 25px under the image (:before): keep that room in the grid row, or the
  // next section (z-index 1, white) covers it when the image is taller than the text
  marginBlock: theme?.breakpoints?.isMobile ? 15 : credit ? "0 25px" : "initial",
  backgroundImage: imageUrl ? `url("${imageUrl}")` : undefined,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  marginRight: !isLeftPosition && theme?.breakpoints?.isMobile ? -10 : 0,
  marginLeft: isLeftPosition && theme?.breakpoints?.isMobile ? -10 : 0,
  borderRadius: isLeftPosition ? "0 24px 24px 0" : "24px 0 0 24px",
  ":before": credit
    ? {
        content: `"${credit}"`,
        position: "absolute",
        bottom: -25,
        left: isLeftPosition ? 24 : "auto",
        right: isLeftPosition ? "auto" : 24,
        width: "auto",
        height: "auto",
        color: theme?.colors?.primaryGrey,
        borderRadius: 4,
        fontSize: "0.75rem",
        lineHeight: 1,
        fontWeight: 400,
        fontFamily: theme?.font?.manrope,
      }
    : undefined,
  "@media (min-width: 1024px)": {
    gridColumn: isLeftPosition ? "1/7" : "11/-1",
  },
  "@media (min-width: 1440px)": {
    gridColumn: isLeftPosition ? "1/6" : "12/-1",
  },
}));

export const CardWrapper = styled.div<{styles?: CSSObject}>(({styles}) => ({
  display: "flex",
  flexDirection: "column",
  paddingInline: 26,
  paddingBlock: "16px 22px",
  marginTop: 22,
  ...styles,
}));

export const TitleWrapper = styled.div({
  position: "relative",
  display: "flex",
  flexDirection: "row",
  columnGap: 10,
  alignItems: "center",
});
